import { CardDeck, CreateCardDeckData } from "@olagg/db-types"
import { AdminCardDecksEndpoints } from "../endpoints/adminEndpoints"
import { fetcher } from "../fetcher"
import { useToast } from "@chakra-ui/react"
import { useQ } from "./useQ"
import { useState } from "react"

export const useAdminCardDecks = () => {
  const toast = useToast();
  const [cardDeck, setCardDeck] = useState<CardDeck>();

  const response = useQ<{decks: CardDeck[]}>(AdminCardDecksEndpoints.list());

  const success_toast = (description: string) => {
    toast({
      title: 'Mazo de Cartas',
      colorScheme: 'olaggPink',
      status: 'success',
      description,
      position: 'bottom-right'
    });
  }
  
  const error_toast = (error: any) => {
    toast({
      title: 'Error',
      colorScheme: 'olaggYellow',
      status: 'error',
      description: error.errors,
      position: 'bottom-right'
    });
  }

  const createCardDeck = async (data: CreateCardDeckData, callback?: () => void) => {
    return await fetcher(AdminCardDecksEndpoints.create({ card_deck: data }))
      .then(() => {
        success_toast('Mazo de cartas creado con éxito');
        response.mutate();
        callback?.();
      })
      .catch((error: any) => {
        error_toast(error);
      })
  }

  const updateCardDeck = async (id: string | number, data: Partial<CreateCardDeckData>, callback?: () => void) => {
    return await fetcher(AdminCardDecksEndpoints.update(id, { card_deck: data }))
      .then(() => {
        success_toast('Mazo de cartas actualizado con éxito');
        response.mutate();
        callback?.();
      })
      .catch((error: any) => {
        error_toast(error);
      })
  }

  const deleteCardDeck = async (id: string | number) => (
    fetcher(AdminCardDecksEndpoints.delete(id))
      .then(() => {
        success_toast('Mazo de cartas eliminado con éxito');
        response.mutate();
      })
      .catch((error: any) => {
        console.log(error);
        error_toast(error);
      })
  )

  const find = (id: string | number) => {
    fetcher(AdminCardDecksEndpoints.show(id))
      .then(res => setCardDeck(res.deck))
  }

  return {
    ...response,
    cardDeck,
    find,
    createCardDeck,
    updateCardDeck,
    deleteCardDeck,
  }
} 